import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';

/**
 * Hook for native camera access on iOS/Android
 * Falls back to web file input when running in browser
 */
export const useNativeCamera = () => {
  const isNative = Capacitor.isNativePlatform();

  /**
   * Take a photo using the device camera
   * Returns base64 string or null if cancelled/failed
   */
  const takePhoto = async (): Promise<string | null> => {
    if (!isNative) {
      // Running in web browser - caller should use file input
      return null;
    }

    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: CameraSource.Camera
      });

      return image.base64String || null;
    } catch (error) {
      console.error('Camera error:', error);
      return null;
    }
  };

  /**
   * Pick a photo from the device photo library
   * Returns base64 string or null if cancelled/failed
   */
  const pickPhoto = async (): Promise<string | null> => {
    if (!isNative) {
      // Running in web browser - caller should use file input
      return null;
    }

    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: CameraSource.Photos
      });

      return image.base64String || null;
    } catch (error) {
      console.error('Photo picker error:', error);
      return null;
    }
  };

  return { 
    takePhoto, 
    pickPhoto, 
    isNative 
  };
};
